module.exports = __webpack_public_path__ + "img/审核成功.5b94b5c3.png";